<template>
  <div class="status-wrapper">
    <div class="status-bar">
      <timeline-step
        v-for="step in timeline"
        :key="step.id"
        :status="step.status"
        :step="step.step"
        :title="step.title"
        :maximumStep="stepCount"
        :configuration="step"
        @titleClicked="currentstep = $event"
        @todoListClicked="emit('todoListClicked')"
      >
        <template v-slot:caption v-if="useV2 && currentstep === step.step">
          <timeline-step-description
            class="mobile"
            :step="step.step"
            :status="selectedStep.status"
            @viewCertificationUpdates="emit('viewCertificationUpdates')"
          />
        </template>
        <SLCRedirectButton
          v-if="showSLCButtonFundsDisbursedStep"
          :openInNewTab="false"
        />
      </timeline-step>
    </div>
    <template v-if="useV2">
      <div class="divider"></div>
      <timeline-step-description
        :step="selectedStep.step"
        :status="selectedStep.status"
        @viewCertificationUpdates="emit('viewCertificationUpdates')"
      />
    </template>
  </div>
</template>

<script setup lang="ts">
import { onMounted } from "vue";
import { useStore } from "vuex";
import TimelineStep from "@/components/timeline/TimelineStep.vue";
import TimelineStepDescription from "@/components/timeline/TimelineStepDescription.vue";
import useApplicationStatus from "@/composables/application-status/useApplicationStatus";
import SLCRedirectButton from "@/components/buttons/SLCRedirectButton.vue";

useStore();

const {
  currentActiveStep,
  currentActiveStepDetails,
  currentstep,
  productTypeId,
  selectedStep,
  stepCount,
  showSLCButtonFundsDisbursedStep,
  timeline,
  useV2,
} = useApplicationStatus();

const emit = defineEmits<{
  (e: "todoListClicked"): void;
  (e: "viewCertificationUpdates"): void;
}>();

onMounted(() => {
  currentstep.value = currentActiveStep.value;
});

defineExpose({
  currentActiveStep,
  currentActiveStepDetails,
  productTypeId,
});
</script>
